<template>
  <span>

    <main role="main">
      <article>
        <div class="col-sm-6 col-sm-offset-3">
          <h1>{{ content.contactus.formData.title }}</h1>
          <div id="errorMessages">
            <ul></ul>
          </div>
          <div id="successMessage">

          </div>

          <form action="/pub/vu/contacts/processContact.jsp" method="POST" id="form1">
            <div id="firstName-group" class="form-group">
              <label for="firstName">{{ content.contactus.formData.labels.firstName }}</label>
              <input type="text" class="form-control" id="firstName" name="firstName"
                :placeholder="[[content.contactus.formData.placeholders.firstName]]" required />
            </div>

            <div id="surname-group" class="form-group">
              <label for="surname">{{ content.contactus.formData.labels.surname }}</label>
              <input type="text" class="form-control" id="surname" name="surname"
                :placeholder="[[content.contactus.formData.placeholders.surname]]" required />
            </div>

            <div id="tel-group" class="form-group">
              <label for="telno">{{ content.contactus.formData.labels.telephone }}</label>
              <input type="text" class="form-control" id="telno" name="telno"
                :placeholder="[[content.contactus.formData.placeholders.telephone]]"   pattern="[0-9]*" minlength="10" maxlength="15"  required/>
            </div>

            <div id="email-group" class="form-group">
              <label for="email">{{ content.contactus.formData.labels.email }}</label>
              <input type="email" class="form-control" id="email" name="email"
                :placeholder="[[content.contactus.formData.placeholders.email]]"  required />
            </div>

            <div id="subject-group" class="form-group">
              <label for="subject">{{ content.contactus.formData.labels.subject }}</label>
              <input type="text" class="form-control" id="subject" name="subject"
                :placeholder="[[content.contactus.formData.placeholders.subject]]" required />
            </div>
            <div id="enquiry-group" class="form-group">
              <label for="enquiryAlias">{{ content.contactus.formData.labels.enquiry }}</label>
              <textarea rows="10" cols="50" class="form-control" id="enquiryAlias" name="enquiryAlias"
                :placeholder="[[content.contactus.formData.placeholders.enquiry]]" required></textarea>
            </div>

            <button type="submit" class="btn btn-success" id="submitButton">
              {{ content.contactus.formData.button.text }}
            </button>
          </form>
        </div>
      </article>

    </main>
  </span>
</template>





<script>
import $ from "jquery";
import Content from "../data/content";



export default {
  name: 'contactus',
  metaInfo: {
    title: 'home to live ltd: Contact us',
    meta: [
      {
        vmid: 'description',
        name: 'description',
        content: 'Contact us at home to live ltd with this form.'
      },
      {
        vmid: 'keywords',
        name: 'keywords',
        content: 'Contact, us, conatctus, form'
      },      
      {
        vmid: 'author',
        name: 'author',
        content: 'Adebayo Odutola.'
      },      
    ]    

  },
  data() {
    return {
      content:Content
    };
  },
  mounted: function () {
    
    $("form").submit(function (event) {
    var formData = {
      firstName: $("#firstName").val(),
      surname: $("#surname").val(),
      email: $("#email").val(),
      telno: $("#telno").val(),
      subject: $("#subject").val(),
      enquiryAlias: $("#enquiryAlias").val(),
    };

    $.ajax({
      type: "POST",
      url: "/pub/vu/contacts/processContact.jsp",
      data: formData,
      dataType: "json",
      encode: true,
    }).done(function (data) {
      /*console.log(data.errors);
      console.log(data.successMessages);*/
      $("input, textarea").removeClass("error")
      $('#errorMessages ul li').remove();
      

      $.each(data.errors, function(key, value) {      
        $('#errorMessages ul').append("<li>"+value+"</li>");     
      });    
      $.each(data.errors, function(key) {
        $('[name="'+key+'"]').addClass("error");   
      });
    

      
      if (data.success){

        $.each(data.successMessages, function(key, value) { 
          $('#successMessage').empty();
          $('#successMessage').hide();
          $('#successMessage').append(value);     
          $('#successMessage').show( "slow", function() {
             // Animation complete.
          });    
          $('#form1').hide();

        });   
        
      }

    });

    event.preventDefault();
  });
  }
}
</script>

<style>
.error {
  border-color:red;
}
main article{
    padding: 145px 2%;
    .col-sm-6{
      margin: auto;
      .form-group{
        margin: 10px 0;
      }
    }
    h1, #successMessage{
      text-align: center;
    }
}
button{
  width: 100%;
  margin: 10px 0;
}
#errorMessages ul {
 color: red;
 padding: 0px 20px ;
}

</style>
